import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const placesSearchResultsSelector = (state: AppState) => state.frontendState.places.searchResults;
export const usePlacesSearchResultsSelector = () => useSelector(placesSearchResultsSelector);

const placesSearchExpandedSearchesSelector = (state: AppState) => state.frontendState.places.expandedSearchIds;
export const usePlacesSearchExpandedSearchesSelector = () => useSelector(placesSearchExpandedSearchesSelector);

const placesStartingLocationSelector = (state: AppState) => state.frontendState.places.startingLocation;
export const usePlacesStartingLocationSelector = () => useSelector(placesStartingLocationSelector);

const placesHoveredSearchIdSelector = (state: AppState) => state.frontendState.places.hoveredSearchId;
export const usePlacesHoveredSearchIdSelector = () => useSelector(placesHoveredSearchIdSelector);

const placesHoveredPlaceInListSelector = (state: AppState) => state.frontendState.places.hoveredPlaceInList;
export const usePlacesHoveredPlaceInListSelector = () => useSelector(placesHoveredPlaceInListSelector);
